import React from "react";
import { TextInput } from "@common/textInput";

import { SelectList } from "@common/selectList";
import { Props } from "./types";
import styles from "./styles.scss";
import { Checkbox } from "@common/checkbox";
import classNames from "classnames";
import { ToggleArrow } from "@common/toggleArrow";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";

const scopes = [
  { name: "openid", value: "openid" },
  { name: "email", value: "email" },
  { name: "profile", value: "profile" },
  { name: "offline_access", value: "offline_access" },
];

function ScopeSelect({ selectedScopes, select }: Props) {
  const selectedScopeOptions = scopes.filter(({ value }) =>
    selectedScopes.find((scope) => value === scope),
  );

  return (
    <SelectList
      rootClassName={styles.scopeSelect}
      listClassName={styles.listRoot}
    >
      {({ isOpen }) => ({
        input: (
          <div className={classNames(styles.input, { [styles.open]: isOpen })}>
            <p className={styles.name}>
              {selectedScopeOptions
                ? selectedScopeOptions.map(({ name }) => name).join(", ")
                : ""}
            </p>
            <div className={styles.iconBox}>
              <ToggleArrowIcon className={styles.icon} />
            </div>
          </div>
        ),
        list: (
          <div className={styles.list}>
            {scopes.map((scope) => {
              const isSelected = !!selectedScopes.find((s) => s === scope.name);

              return (
                <div
                  key={scope.value}
                  className={styles.item}
                  onClick={() =>
                    select(
                      isSelected
                        ? selectedScopes.filter((s) => s !== scope.value)
                        : [...selectedScopes, scope.value],
                    )
                  }
                >
                  <Checkbox isChecked={isSelected} />
                  <p>{scope.name}</p>
                </div>
              );
            })}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ScopeSelect };
